// 忠诚度管理-店铺装修

import {
  get,
  post,
  postJson,
  put,
  deleteApi,
  postUrl,
  putJson,
} from "../axios2";

const RESOURCE_BASE_PATH = "/decorationInfo";

//添加装修模板
export const addFitmentTemplate = (p) => postJson(`${RESOURCE_BASE_PATH}`, p);

// 修改装修模板
export const alterFitmentTemplate = (p) => put(`${RESOURCE_BASE_PATH}`, p);

// 设置当前使用的装修模板
export const useFitmentTemplate = (id) =>
  put(`${RESOURCE_BASE_PATH}/current/${id}`);

// 查看装修模板详细信息
export const TemplateParticularList = (id) =>
  get(`${RESOURCE_BASE_PATH}/detail/${id}`);

// 获取装修模板列表
export const fitmentTemplateList = (p) => get(`${RESOURCE_BASE_PATH}/list`, p);

//  修改装修模板名字
export const alterFitmentTemplateRename = (p) =>
  put(`${RESOURCE_BASE_PATH}/rename/${id}`, p);

// 删除装修模板
export const DELETETemplateList = (id) =>
  deleteApi(`${RESOURCE_BASE_PATH}/${id}`);
